import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "profile-menu-content__navigation-section" }
const _hoisted_2 = { class: "profile-menu-content__navigation" }
const _hoisted_3 = { class: "profile-menu-content__logout" }

import { computed, type PropType } from 'vue';

import useNavigationLinks from '@exchange/layouts/app-header/useNavigationLink';
import { accountService } from '@exchange/libs/account/service/src';
import { useLogInOut } from '@exchange/libs/auth/ui/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import ExchangeMobileOverlay from '@exchange/libs/overlays/ExchangeMobileOverlay.vue';

import ProfileUserSection from './ProfileUserSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenuContent',
  props: {
  /** Function to close a menu */
  closeMenu: { type: Function as PropType<() => void>, default: () => {} },
},
  setup(__props) {



const { isXS } = useMQBreakpoints();
const { processingLogOut, logout } = useLogInOut();

const { navLinks } = useNavigationLinks();

const { userName, userEmail, accountUserChecksActionRequired, accountIdHolder, userIsBroker } = accountService;

const contentNotScrollable = computed(() => accountUserChecksActionRequired.value || processingLogOut.value);

const profileLinks = computed(() => {
  const { settings, levels, partners, tradingAccounts, documents, exports, help, blog, legal, keyInformationDocuments } = navLinks.value;

  const links = [settings, levels, partners, documents, ...(userIsBroker.value ? [] : [exports]), help, blog, legal, keyInformationDocuments];

  if (!isXS.value) {
    links.splice(0, 0, tradingAccounts);
  }

  return links;
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_list_item = _resolveComponent("x-list-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['profile-menu-content', { 'profile-menu-content--not-scrollable': contentNotScrollable.value }])
  }, [
    (_unref(isXS))
      ? (_openBlock(), _createBlock(ExchangeMobileOverlay, {
          key: 0,
          class: "profile-menu-content__overlay"
        }))
      : _createCommentVNode("", true),
    _createVNode(ProfileUserSection, {
      class: "profile-menu-content__user-section",
      "with-secondary-info": _unref(isXS),
      "user-email": _unref(userEmail),
      "account-holder-id": _unref(accountIdHolder),
      "user-name": _unref(userName)
    }, null, 8, ["with-secondary-info", "user-email", "account-holder-id", "user-name"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileLinks.value, (link) => {
          return (_openBlock(), _createBlock(_component_x_list_item, {
            key: link.id,
            class: "profile-menu-content__navigation-item",
            "left-icon-inherit-stroke": true,
            "left-icon-name": link.icon,
            "left-icon-warning": link.iconWithWarning,
            "left-icon-info": link.iconWithInfo,
            title: link.title,
            "router-link": link.route,
            href: link.url,
            onClick: __props.closeMenu
          }, {
            "label-additional-content": _withCtx(() => [
              (_unref(isXS) && !link.external)
                ? (_openBlock(), _createBlock(_component_x_button, {
                    key: 0,
                    class: "profile-menu-content__arrow-link",
                    size: "3xs",
                    variant: "clear"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ot_icon, {
                        class: "profile-menu-content__arrow-link-icon",
                        name: "arrow-right",
                        "uncolored-stroke": "uncolored-stroke"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["left-icon-name", "left-icon-warning", "left-icon-info", "title", "router-link", "href", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_x_button, {
          size: "xs",
          block: _unref(isXS),
          variant: _unref(isXS) ? 'base' : 'dark-outline',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logout)(_unref(isXS))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, {
              class: "profile-menu-content__logout-icon",
              name: "logout"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.userMenu.logout')), 1)
          ]),
          _: 1
        }, 8, ["block", "variant"])
      ])
    ])
  ], 2))
}
}

})